import { r as registerInstance, h, a as Host } from './index-6c4796f9.js';
import { c as cdnUrl } from './constants-36b60b05.js';

const getSvgContent = (url) => {
  const getIconUrl = `${cdnUrl}${url}`;
  const request = fetch(getIconUrl).then(async (res) => {
    if (res.ok) {
      const svgString = await res.text();
      return {
        ok: res.ok,
        status: res.status,
        content: svgString,
      };
    }
    else {
      return {
        ok: res.ok,
        status: res.status,
        content: null,
      };
    }
  });
  return request;
};

const iconCss = ":host{position:relative;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}:host{line-height:0}:host svg{display:inline-block;width:auto;height:1em}.icon{display:inline-block;}.icon--micro{font-size:12px}.icon--tiny{font-size:16px}.icon--small{font-size:20px}.icon--medium{font-size:24px}.icon--large{font-size:32px}.icon--huge{font-size:40px}.icon--giant{font-size:48px}";

const FuelIcon = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.svg = undefined;
    this.name = undefined;
    this.size = undefined;
    this.iconStyle = 'outlined';
  }
  watchPropHandler() {
    this.loadIcon();
  }
  getClassMap() {
    return {
      'icon': true,
      'icon--micro': this.size === 'micro',
      'icon--tiny': this.size === 'tiny',
      'icon--small': this.size === 'small',
      'icon--medium': this.size === 'medium',
      'icon--large': this.size === 'large',
      'icon--huge': this.size === 'huge',
      'icon--giant': this.size === 'giant',
    };
  }
  async loadIcon() {
    if (!this.name)
      return;
    const cacheKey = `${this.iconStyle}/${this.name}.svg`;
    const basePath = '/svg/icons';
    if (!FuelIcon.svgCache[cacheKey]) {
      FuelIcon.svgCache[cacheKey] = getSvgContent(`${basePath}/${cacheKey}`)
        .then(svg => {
        if (svg.ok && svg.content) {
          return svg.content;
        }
        return '';
      })
        .catch(err => {
        console.error(`Failed to load icon ${cacheKey}:`, err);
        delete FuelIcon.svgCache[cacheKey];
        return '';
      });
    }
    this.svg = await FuelIcon.svgCache[cacheKey];
  }
  connectedCallback() {
    this.loadIcon();
  }
  render() {
    return (h(Host, { role: "img", "aria-label": this.name }, h("div", { innerHTML: this.svg, class: this.getClassMap() })));
  }
  static get watchers() { return {
    "name": ["watchPropHandler"],
    "iconStyle": ["watchPropHandler"]
  }; }
};
FuelIcon.svgCache = {};
FuelIcon.style = iconCss;

export { FuelIcon as fuel_icon };

//# sourceMappingURL=fuel-icon.entry.js.map